import { Component, OnInit } from '@angular/core';
import { FormGroup, Validators, FormBuilder, FormControl } from '@angular/forms';
import { NavigationService } from 'services/navigation.service';
import { UserService } from 'services/user.service';
import { AlertService } from 'services/alert.service';
import { ActivatedRoute, Router } from '@angular/router';
import { ActiveUserSessionService } from 'services/activeusersession.service';
import { AuthenticationService } from 'services/authentication.service';
import { PasswordStrengthValidator } from 'app/shared/validators/password-strength.validators';
import { FriendDetailsService } from 'services/frienddetails.service';

@Component({
  selector: 'app-registerbyreference',
  templateUrl: './registerbyreference.component.html',
  styleUrls: ['./registerbyreference.component.scss']
})
export class RegisterbyreferenceComponent implements OnInit {
  form: FormGroup;
  titleList: any[];
  dropdownSettings = {};
  fieldTextType: boolean;
  fieldConfirmTextType: boolean;
  productId: any;
  returnUrl: any;
  routeParams: any;
  friendDetailsId: number;
  friendDetails: any;

  constructor(private formBuilder: FormBuilder,
    private userService: UserService,
    private navigationService: NavigationService,
    private activeUserSessionService: ActiveUserSessionService,
    private authService: AuthenticationService,
    private route: ActivatedRoute,
    private friendDetailsService: FriendDetailsService,
    private alertService: AlertService, private router: Router) {
    this.initializeValidators();
    this.dropdownSettings = {
      singleSelection: false,
      idField: 'key',
      textField: 'value',
      selectAllText: 'Select All',
      unSelectAllText: 'Un Select All',
      itemsShowLimit: 4,
      allowSearchFilter: true
    };

    this.routeParams = route.snapshot.params;
    this.friendDetailsId = +this.routeParams.id;
  }
  ngOnInit() {

    // this.route.queryParams.subscribe(params => {
    //   this.form.patchValue({
    //     firstName: params['firstName'] || '',
    //     lastName: params['lastName'] || '',
    //     cellNumber: params['cellNumber'] || '',
    //     email: params['email'] || ''
    //   });
    // });

    this.getFriendDetails();
    this.getTitleType(false);
    this.returnUrl = this.route.snapshot.queryParams['returnUrl'] || '/';

  }

  initializeValidators() {
    this.form = this.formBuilder.group({
      title: ['', [Validators.required]],
      firstName: ['', [Validators.required, Validators.pattern('.*\\S.*[a-zA-z ]')]],
      lastName: ['', [Validators.required, Validators.pattern('.*\\S.*[a-zA-z ]')]],
      identificationNumber: ['', [Validators.required]],
      mobileNumber: ['', [Validators.required, Validators.pattern('[0-9]*')]],
      email: ['', [Validators.required, Validators.email]],
      password: ['', [Validators.required, PasswordStrengthValidator, Validators.minLength(8)]],
      confirmpassword: ['', [Validators.required]],
      salesRepCode: [''],
      friendDetailsId: [this.friendDetailsId],
    });
  }

  onSave() {

    if (this.form.value.mobileNumber) {
      if (this.form.value.mobileNumber.length < 9) {
        this.alertService.warning('Please enter valid cellphone number');
        return;
      }
      else if (this.form.value.mobileNumber.length == 10) {
        var mobile = this.form.value.mobileNumber[0];
        if (mobile != 0) {
          this.alertService.warning('Please enter valid cellphone number');
          return;
        }
      }
    }

    if (this.form.valid) {
      this.userService.save(this.form.value).subscribe(result => {
        if (result) {
          if (result.value > 0) {

            this.authService.login(this.form.value.email, this.form.value.password).subscribe((result) => {
              this.router.navigate([this.returnUrl]);
              if (result) {
                if ((result.isFailure == true)) {
                  this.alertService.warning('Login Failed!');
                }
                else {
                  this.navigationService.goToDashboard();
                }

              }
            });
            this.alertService.success('Registered successfully!');
          }
          else if (result.failures[0] === "Email already exists") {
            this.alertService.warning('Email already exist');
          }
          else if (result.failures[0] === "Mobile Number already exists") {
            this.alertService.warning('Cellphone Number already exists');
          }
          else {
            this.alertService.warning('Something wrong your request not accepted');
          }
        }
      });
    } else {
      this.validateFormControl();
    }
  }



  getTitleType(refresh) {
    try {
      this.userService.getTitleType(refresh).subscribe(result => {
        this.titleList = [];
        this.titleList = result;
        // console.log('this.weekDaysList', this.weekDaysList);
      });

    } catch (error) {

    }
  }

  getFriendDetails() {

    this.friendDetailsService.getFriendDetailsById(this.friendDetailsId).subscribe(result => {
      if (result) {
        this.friendDetails = result;
        if (this.friendDetails != null) {
          this.form.controls['firstName'].setValue(this.friendDetails.firstName);
          this.form.controls['lastName'].setValue(this.friendDetails.lastName);
          this.form.controls['email'].setValue(this.friendDetails.email);
          this.form.controls['mobileNumber'].setValue(this.friendDetails.cellNumber);
          this.form.controls['friendDetailsId'].setValue(this.friendDetailsId);
        }

      }
    });

  }


  onCancel() {
    this.router.navigateByUrl('login');
  }
  toggleFieldTextType() {
    this.fieldTextType = !this.fieldTextType;
  }
  toggleConfirmFieldTextType() {
    this.fieldConfirmTextType = !this.fieldConfirmTextType;
  }
  validateFormControl() {
    Object.keys(this.form.controls).forEach(field => {
      const control = this.form.get(field);
      if (control instanceof FormControl) {
        control.markAsTouched({
          onlySelf: true
        });
      }
    })
  }

  titleChange(eve) {

  }


}
